import { createFileRoute } from '@tanstack/react-router';
import { StoriesScreen } from '../features/stories/StoriesScreen';

/** Le Fil. Pas de RequireRole : la garde est le flag, appliqué par l'API et relu par l'écran. */
export const Route = createFileRoute('/nouveautes')({
  component: StoriesScreen,
});
